import { render, staticRenderFns } from "./AnnouncementList.vue?vue&type=template&id=52a233c6&scoped=true&"
import script from "./AnnouncementList.vue?vue&type=script&lang=js&"
export * from "./AnnouncementList.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementList.vue?vue&type=style&index=0&id=52a233c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a233c6",
  null
  
)

export default component.exports